import { render } from "./CustomerOrdersModal.vue?vue&type=template&id=db0ac4d0&scoped=true"
import script from "./CustomerOrdersModal.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersModal.vue?vue&type=script&lang=js"

import "./CustomerOrdersModal.vue?vue&type=style&index=0&id=db0ac4d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db0ac4d0"]])

export default __exports__